import React, { memo, useMemo } from 'react';
import { ColorValueStrict } from 'fronton-react';
import cn from 'clsx';
import { Typography, TypographyTextProps } from '../typography';
import { customIcon, list } from './list-styles';

type ListProps = {
  children: React.ReactNode;
  className?: string;
  listStyle?: 'disc';
};

export const List: React.FC<ListProps> = memo(({ children, className, listStyle }) => {
  const classNames = useMemo(() => cn(className, list, { [customIcon]: !listStyle }), [
    className,
    listStyle,
  ]);

  return <ul className={classNames}>{children}</ul>;
});

type ListItemProps = {
  adaptive?: boolean;
  className?: string;
  columnGap?: number;
  leftIcon?: React.ReactNode;
  text?: string;
  children?: React.ReactNode;
  color?: ColorValueStrict;
} & Partial<TypographyTextProps>;

export const ListItem: React.FC<ListItemProps> = memo(
  ({ adaptive = false, className, children, color, text, leftIcon, variant = 'm', size = 'body_long' }) => (
    <li>
      {children || (
        <>
          {leftIcon}
          <Typography adaptive={adaptive} color={color} className={className} variant={variant} size={size}>
            {text}
          </Typography>
        </>
      )}
    </li>
  )
);
